import { getRows } from './utils';
export const useMultiRow = ({ definition, svgViewBox, rows: passedRows }) => {
    if (passedRows) {
        return { rows: passedRows };
    }
    const rows = getRows({ definition, svgViewBox });
    return { rows };
};
//# sourceMappingURL=use-multi-row.js.map